import '@fortawesome/fontawesome-free/css/all.css'
// import './style.scss'
